export default class PopupRequestCancelled extends Error {
  constructor() {
    super("Multiple popup operations are triggered");
  }
}
